"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function fontSizes(context) {
  var names = {
    title: 'font-title',
    title2: 'font-title2',
    base: 'font-base',
    caption: 'font-caption',
    xsmall: 'font-xsmall'
  };
  var css = context.css,
      font = context.font;
  var sizes = font.sizes;
  return {
    title: css(names.title, sizes.title),
    title2: css(names.title2, sizes.title2),
    base: css(names.base, sizes.base),
    caption: css(names.caption, sizes.caption),
    xsmall: css(names.xsmall, sizes.xsmall)
  };
}

exports.fontSizes = fontSizes;